import anime from 'animejs'

export default {
  handle(btn, child) {
    const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
    const parent = $(btn).closest('.component');
    const currentID = $(parent).attr('id');
    let iTheElementCount = $(parent).attr('data-element-count');

    const wrap = $(parent).find('.items-wrapper');

    var allItems = wrap.find(child);

    var iTheMaxHeight = wrap.outerHeight();
    var rowGap = parseFloat(wrap.css('row-gap'));

    var counter = 0;
    var iTheDelay = 80;

    var iTheTotalDelay = (allItems.length - iTheElementCount) * iTheDelay;
    var animateTo = $('#'+currentID);

    let hiddenItems = wrap.find('.hidden');

    if (hiddenItems.length) {
      wrap.find(child).css('--transition-delay-factor', 0);

      hiddenItems.each(function() {

        if (counter < iTheElementCount) {
          $(this).css('--transition-delay-factor', counter);
          $(this).removeClass('hidden -in').addClass('-out');

          iTheMaxHeight += $(this).outerHeight();
          iTheMaxHeight += rowGap;
          wrap.css('max-height', iTheMaxHeight);

          setTimeout(() => {
          }, iTheDelay * counter);
        }
        counter++;
      });

      setTimeout(() => {
        if (!$( wrap ).find( '.hidden' ).length) {
          $(btn).children('span').text($(btn).attr('data-close-label'));
          $(btn).children('.icon').addClass('arrow-up');
        }
      }, iTheDelay * iTheElementCount);
    } else {
      $(btn).children('.icon').removeClass('arrow-up');
      $(btn).children('span').text($(btn).attr('data-open-label'));
      wrap.find(child).css('--transition-delay-factor', 0);
      wrap.css('max-height', iTheMaxHeight);

      $(allItems.get().reverse()).each(function(index) {
        if (allItems.length - index > iTheElementCount) {

          $(this).css('--transition-delay-factor', index);
          $(this).removeClass('-in').addClass('-out');
          iTheMaxHeight -= $(this).outerHeight();
          iTheMaxHeight -= rowGap;

          setTimeout(() => {
            $(this).addClass('hidden');
          }, 200 + iTheTotalDelay );
        }
      });

      wrap.css('max-height', iTheMaxHeight);

      setTimeout(() => {
        anime({
          targets: scrollElement,
          scrollTop: animateTo.offset().top - ($(window).height() * .15),
          duration: 600,
          easing: 'easeInOutQuart',
        });
      }, 200);
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/components/load-more.js